export const choices = ["Āe", "Kāo"];

export const aeChoices = ["Āe"];
